import request from '@/utils/request';

export interface WalletToken {
    balance: number;
    pending_amount: number;
    exchange_uid?: string;
    last_sync_time?: string;
}

export interface WalletConsumer {
    balance: number;
    total_income: number;
}

export interface WalletMerchant {
    shop_id: number;
    shop_name: string;
    pending_amount: number;
    available_balance: number;
    frozen_amount: number;
    total_settled_amount: number;
    deposit_balance: number;
}

export interface WalletAgent {
    agent_id: number;
    level: string;
    pending_amount: number;
    available_balance: number;
    frozen_amount: number;
    total_settled_amount: number;
}

export interface MyWalletResponse {
    token: WalletToken;
    consumer: WalletConsumer;
    merchant?: WalletMerchant;
    agent?: WalletAgent;
}

export interface TransactionItem {
    id: number;
    trade_no: string;
    role_type: 'CONSUMER' | 'MERCHANT' | 'AGENT' | 'PLATFORM';
    asset_type: string;
    amount: number;
    balance_snapshot: number;
    business_type: string;
    source_id?: string;
    created_at: string;
}

export interface TransactionListParams {
    page?: number;
    page_size?: number;
    role_type?: string;
    asset_type?: string;
}

export interface ApplyWithdrawParams {
    role_type: string;
    amount: number;
    bank_card_id: number;
}

export interface WithdrawResponse {
    id: number;
    withdraw_no: string;
    role_type: string;
    amount: number;
    status: string;
    created_at: string;
    audit_remark?: string;
}

export interface WithdrawItem extends WithdrawResponse {
    actual_amount: number;
    fee: number;
    audit_time?: string;
    auditor_id?: number;
    payment_no?: string;
    payment_time?: string;
    account_info?: any;
    bank_card_id?: number;
}

export interface WithdrawListParams {
    page?: number;
    page_size?: number;
    status?: string;
    role_type?: string;
    withdraw_no?: string;
}

// 钱包银行卡相关 (通用接口)
export interface BankCardCreate {
    bank_name: string;
    branch_name?: string;
    card_no: string;
    account_name: string;
    is_default?: boolean;
}

export interface BankCardResponse extends BankCardCreate {
    id: number;
    user_id?: number;
    shop_id?: number;
    created_at: string;
}

export function getMyWallet() {
    return request<MyWalletResponse>({
        url: '/wallet/my',
        method: 'GET'
    });
}

export function getTransactions(params: TransactionListParams) {
    return request<{ items: TransactionItem[], total: number }>({
        url: '/wallet/transactions',
        method: 'GET',
        params
    });
}

export function applyWithdraw(data: ApplyWithdrawParams) {
    return request<WithdrawResponse>({
        url: '/wallet/withdraw/apply',
        method: 'POST',
        data
    });
}

export function getMyWithdrawList(params: WithdrawListParams) {
    return request<{ items: WithdrawItem[], total: number }>({
        url: '/wallet/withdraw/my-list',
        method: 'GET',
        params
    });
}

export function getWalletBankCards() {
    return request<BankCardResponse[]>({
        url: '/wallet/bank-cards',
        method: 'GET'
    });
}

export function createWalletBankCard(data: BankCardCreate) {
    return request<BankCardResponse>({
        url: '/wallet/bank-cards',
        method: 'POST',
        data
    });
}

/**
 * 获取数字凭证中台免密登录跳转链接
 */
export function getTokenLoginUrl() {
    return request<string>({
        url: '/wallet/token/login-url',
        method: 'GET'
    });
}
